import { Controller } from '@hotwired/stimulus';

// Toggles a content block open/closed (open by default). The is-collapsed class
// on the root drives the chevron rotation and the show/hide labels via CSS.
export default class extends Controller {
  static targets = ['content'];

  toggle() {
    const collapsed = this.element.classList.toggle('is-collapsed');
    this.contentTarget.hidden = collapsed;
  }
}
